/**
 * Checks the current URL and routes to the correct chat service by panel region.
 * @returns {String} Chat service URL
 */
export const chatServiceUrl = () => {
  const hostname = window.location.hostname;
  // NOTE: Chat service is only deployed to US and CA right now.
  const CA_HOST_MATCHERS = ['ca.insights', 'insights-ca'];

  if (CA_HOST_MATCHERS.some((matcher) => hostname.includes(matcher))) {
    return import.meta.env.VITE_CHAT_ENDPOINT_CA;
  }

  return import.meta.env.VITE_CHAT_ENDPOINT;
};

/**
 * List of domains that are considered part of the EU region.
 * @type {string[]}
 */
const EU_REGION_DOMAINS = [
  'insights-de.dev.panel-insights.numerator.cloud',
  'verifiedvoices-de.dev.panel-insights.numerator.cloud',
  'insights-de.stg.panel-insights.numerator.cloud',
  'verifiedvoices-de.stg.panel-insights.numerator.cloud',
  'de.insights.numerator.com',
  'de.verifiedvoices.numerator.com',
];

/**
 * Checks if the current URL belongs to a deployed EU domain.
 * @returns {boolean} `true` if the current site is an EU domain, otherwise `false`
 */
export const isEUDomain = () => {
  let hostname = window.location.hostname;

  // Remove 'www.' if present
  hostname = hostname.replace(/^www\./, '');

  return EU_REGION_DOMAINS.includes(hostname);
};

/**
 * List of domains that are considered part of the AP region.
 * @type {string[]}
 */
const AP_REGION_DOMAINS = [
  'insights-kr.dev.panel-insights.numerator.cloud',
  'verifiedvoices-kr.dev.panel-insights.numerator.cloud',
  'insights-kr.stg.panel-insights.numerator.cloud',
  'verifiedvoices-kr.stg.panel-insights.numerator.cloud',
  'kr.insights.numerator.com',
  'kr.verifiedvoices.numerator.com',
];

/**
 * Checks if the current URL belongs to a deployed AP domain.
 * @returns {boolean} `true` if the current site is an AP domain, otherwise `false`
 */
export const isAPDomain = () => {
  let hostname = window.location.hostname;

  // Remove 'www.' if present
  hostname = hostname.replace(/^www\./, '');

  return AP_REGION_DOMAINS.includes(hostname);
};

export const isLocalSurveyDomain = import.meta.env.VITE_INSTANT_SURVEY_ISLOCAL === 'true';
